import * as React from 'react'
import { YAxis as RechartsYAxis } from 'recharts'

import { shortFormatNumber } from '../../util'

export class YAxis extends React.Component<
  Omit<React.ComponentProps<typeof RechartsYAxis>, 'tickCount'> & { tickCount?: number | null }
> {
  static displayName = RechartsYAxis.displayName

  static defaultProps = {
    ...RechartsYAxis.defaultProps,
    className: 'fill-gray-500 dark:fill-gray-300',
    tickLine: false,
    axisLine: false,
    tick: {
      fontSize: 10,
      fontWeight: 500, // Different from XAxis
      fill: '',
    },
    tickFormatter: shortFormatNumber,
  }

  render() {
    return <RechartsYAxis {...(this.props as any)} />
  }
}
